import React from 'react';
import { X } from 'lucide-react';

interface SharePointHeaderProps {
  systemConfig: { Id: string; ConfigValue: string; }[];
  onClose: () => void;
}

const SharePointHeader: React.FC<SharePointHeaderProps> = ({
  systemConfig,
  onClose
}) => {
  const maxAllowedSites = Number(systemConfig.find(item => item.Id === 'va_max_allowed_sharepoint_sites')?.ConfigValue) || 5;

  return (
    <div className="pl-3 pr-3 pb-3 pt-2 shadow-md sticky top-0 z-10">
      <div className="flex justify-between items-center">
        <div className="flex items-center space-x-2">
          <img src="/sharepoint-logo.png" alt="SharePoint Logo" className="h-5 w-5" />
          <h2 className="text-xl font-semibold text-gray-800">SharePoint Sources</h2>
        </div>
        <button
          onClick={onClose}
          className="text-gray-500 hover:text-gray-700"
        >
          <X className="h-5 w-5" />
        </button>
      </div>
      <p className="text-gray-600 mt-2 ml-8">
        Setup your Chatbot to train itself with content from your SharePoint sources.
        This includes lists and document libraries that you have access to.
        You can specify up to {maxAllowedSites} sources.
      </p>
    </div>
  );
};

export default SharePointHeader;